import { render } from "./RoomsAvailabilityChart.vue?vue&type=template&id=efa3cb98&ts=true"
import script from "./RoomsAvailabilityChart.vue?vue&type=script&lang=ts"
export * from "./RoomsAvailabilityChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__